import {Component, OnInit} from '@angular/core';
import { AuthService } from '../auth.service';
import {AngularFireAuth} from "angularfire2/auth";
import {UserService} from "../../users/shared/user.service";
import {User} from "../../users/shared/user";
import {ObjectObservable} from "../../shared/base/object-observable";

@Component({
  selector: 'app-auth-state',
  templateUrl: './auth-state.component.html',
  styleUrls: ['./auth-state.component.scss']
})
export class AuthStateComponent implements OnInit {

  private userObservable: ObjectObservable<User>;

  constructor(private auth: AuthService,
              private afAuth: AngularFireAuth,
              private userService: UserService) {
  }

  ngOnInit() {
    this.afAuth.authState.subscribe(auth => {
      if (auth) {
        this.userObservable = this.userService.readChild(auth.uid);
      }
    });
  }

  login() {
    return this.auth.login();
  }

  logout() {
    return this.auth.logout();
  }

  get isAuthenticated() {
    return this.auth.isAuthenticated;
  }

  // get user() {
  //   console.log(this.auth.user);
  //   return this.auth.user;
  // }
}

//
// import { Component } from '@angular/core';
//
// import { AuthService } from '../auth.service';
//
// @Component({
//   selector: 'app-auth-state',
//   templateUrl: './auth-state.component.html',
//   styleUrls: ['./auth-state.component.scss']
// })
// export class AuthStateComponent {
//   constructor(private auth: AuthService) { }
//
//   login() {
//     return this.auth.login();
//   }
//
//   logout() {
//     return this.auth.logout();
//   }
//
//   get isAuthenticated() {
//     return this.auth.isAuthenticated;
//   }
//
//   get user() {
//     return this.auth.user;
//   }
// }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/core/auth-state/auth-state.component.ts